
@if (beingEdited) {
	<form>
	<div class="flex-row align-items-center py-16">
		<div class="flex-grow-1">
			<mat-form-field appearance="outline" color="accent" class="w-100" subscriptSizing="dynamic">
				<mat-label>Message Text</mat-label>
				<input matInput
					   autocomplete="off"
					   type=text
					   name="text"
					   [(ngModel)]="editedHeadline.text">
			</mat-form-field>
		</div>
		<div class="action-buttons">
			<button mat-icon-button
					color="accent"
					type="submit"
					(click)="update()"
					[disabled]="!editedHeadline?.text"
					[matTooltip]="'Save'">
				<mat-icon>save</mat-icon>
			</button>
			<button mat-icon-button
					color="accent"
					(click)="cancel()"
					[matTooltip]="'Cancel'">
				<mat-icon>Cancel</mat-icon>
			</button>
		</div>
	</div>
	</form>
} @else {
	<mat-menu #actionsMenu="matMenu">
		<button mat-menu-item
				(click)="edit()">
			<mat-icon>edit</mat-icon>
			Edit message
		</button>
		<button mat-menu-item
				(click)="headlineDeleted.emit()">
			<mat-icon>delete</mat-icon>
			Remove message
		</button>
	</mat-menu>

	<div class="flex-row align-items-center">
		<div class="flex-grow-1">{{ headline().text }}</div>

		<mat-slide-toggle [hideIcon]="true"
						  matTooltip="Display the text on the site"
						  (change)="selectedChanged()"
						  [checked]="headline().selected">
		</mat-slide-toggle>
		<button mat-icon-button
				[matMenuTriggerFor]="actionsMenu">
			<mat-icon>more_vert</mat-icon>
		</button>
	</div>
}
